export function orderScriptsNewestFirst(scripts = []) {
  return [...scripts].reverse();
}

export function createScriptCopyMetadata(script) {
  return {
    name: `${script.name} (Másolat)`,
    room: script.room,
    setting: script.setting
  };
}

export function createScriptItemCopyData(item, scriptId) {
  return {
    script_id: scriptId,
    qty: item.qty,
    size: item.size,
    position: item.position,
    rotation: item.rotation,
    refScriptId: item.refScript,
    refSettings: item.refSettings,
    name: item.name,
    kant: item.kant,
    rotable: item.rotable,
    material: item.material || "",
    details: item.details || ""
  };
}
